import { get, post } from '@/utils/request'


//查询订单默认信息
export const getDefaultInfoByUserId = data => post("/orderDataTemplate/getDefaultInfoByUserId",data);
//获取模板列表
export const getOrderDataTemplateList = data => post("/orderDataTemplate/getOrderDataTemplateList",data);
//获取模板列表(分页)
export const getOrderDataTemplateListPage = data => get("/orderDataTemplate/getOrderDataTemplateListPage",data);
//添加模板
export const addOrderDataTemplate = data => post("/orderDataTemplate/saveOrderDataTemplate",data);
//删除
export const deleteOrderDataTemplate = data => post("/orderDataTemplate/deleteOrderDataTemplate",data);
//更新
export const updateOrderDataTemplate = data => post("/orderDataTemplate/updateOrderDataTemplate",data);



// WEBPACK FOOTER //
// ./src/api/orderDataTemplate.js